import {
  distanceInKmOptions,
  modesOfTransport,
  otherGroupsFormEstablishmentTypes,
  schoolFormEstablishmentTypes,
} from '../../../components/registrationFormComponents/data';

const labelFor = (options, value) =>
  options.find((option) => option.value === value)?.label || value;
const unique = (values) => [...new Set(values.filter(Boolean))];
const isTrue = (value) => value === true || value === 'true';

const yesNoSummary = (classes, field) => {
  if (!classes.length) return '—';
  const values = unique(classes.map((classItem) => (isTrue(classItem[field]) ? 'Oui' : 'Non')));
  return values.join(' et ');
};

const transportModeLabel = (classItem) => {
  const value = classItem.modeOfTransport;
  if (!value) return '';
  const label = labelFor(modesOfTransport, value);
  return value === 'other' && classItem.otherModeOfTransport
    ? `${label} (${classItem.otherModeOfTransport})`
    : label;
};

export const formatRegistrationListItem = (item, index = 0) => {
  const establishment = item.establishmentDetails || {};
  const classes = item.classes || [];
  const studentCounts = item.studentCounts || {};
  const accessibilityNotes = unique(
    classes
      .filter((classItem) => isTrue(classItem.handicap))
      .map((classItem) => classItem.handicapDescription?.trim()),
  );
  const accessibility = yesNoSummary(classes, 'handicap');

  return {
    id: item._id || index + 1,
    name: establishment.name || '—',
    type:
      schoolFormEstablishmentTypes.find((type) => type.value === establishment.type)?.label ||
      otherGroupsFormEstablishmentTypes.find((type) => type.value === establishment.type)?.label ||
      establishment.type ||
      '—',
    otherType: establishment.otherType || '',
    postalCode: establishment.postalCode || '—',
    establishmentCity: establishment.city || '—',
    address: establishment.address || '—',
    department: establishment.department || '—',
    typeOfAcademy: establishment.typeOfAcademy || '—',
    distanceInKm: establishment.distanceInKm
      ? labelFor(distanceInKmOptions, establishment.distanceInKm)
      : '—',
    email: item.inChargePersonEmail || '—',
    privateContract:
      establishment.privateContract == null
        ? '—'
        : isTrue(establishment.privateContract)
          ? 'Oui'
          : 'Non',
    rep: establishment.rep == null ? '—' : isTrue(establishment.rep) ? 'Oui' : 'Non',
    transportMode: unique(classes.map(transportModeLabel)).join(', ') || '—',
    picnicOnSite: yesNoSummary(classes, 'picnicOnSite'),
    picnicTimeSlot:
      unique(
        classes
          .filter((classItem) => isTrue(classItem.picnicOnSite))
          .map((classItem) => classItem.picnicTimeSlot),
      ).join(', ') || '—',
    accessibility: accessibilityNotes.length
      ? `${accessibility} — ${accessibilityNotes.join('; ')}`
      : accessibility,
    students_04_02: Number(studentCounts.thu) || 0,
    students_05_02: Number(studentCounts.fri) || 0,
    total_students: Object.values(studentCounts).reduce(
      (total, count) => total + (Number(count) || 0),
      0,
    ),
    detailUrl: `/admin/dashboard/registrations/${item._id}`,
  };
};
